export const brend = [
    {
        id: 1,
        link: "canon",
        ime: "Canon",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/canon.png",
    },

    {
        id: 2,
        link: "hp",
        ime: "HP",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/hp.png"
    },

    {
        id: 3, 
        link: "kyocera",
        ime: "Kyocera",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/kyocera.png",
    },

    {
        id: 4,
        link: "samsung",
        ime: "Samsung",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/samsung.png",
    },

    {
        id: 5,
        link: "lexmark",
        ime: "Lexmark",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/lexmark.png",
    },

    {
        id: 6,
        link: "xerox",
        ime: "Xerox",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/xerox.png",
    },

    {
        id: 7,
        link: "minolta",
        ime: "Konica Minolta",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/minoltacut.png",
    },

    {
        id: 8,
        link: "epson",
        ime: "Epson",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/epson.png",
    },

    {
        id: 9,
        link: "brother",
        ime: "Brother",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/brother.jpg",
    },

    {
        id: 10,
        link: "panasonic",
        ime: "Panasonic",
        logo: "http://www.greenton.ba/wp-content/uploads/2023/03/panasonic.jpg",
    },
]

export const popular = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 15A",
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "Samsung MLT-1052L",
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP 61A",
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "Samsung SCX-6545/6555",
    }
]

export const novo = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "Canon EF-37",
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "E260A11A",
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "Kyocera TK-17",
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "Xerox 108R00909",
    }
]

export const canon = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        link: "EF_37",
        ime: "Canon EF-27",
        kompatibilnost: "Canon LB 3200, LBP 300N, MF3110, MF5630",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        link: "FX_10",
        ime: "Canon FX 10",
        kompatibilnost: "Canon MF4010, 4320, 4690",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        link: "CRG-039H",
        ime: "Canon CRG-039H",
        kompatibilnost: "Canon LBP351/352",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 25000,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        link: "CRG-041",
        ime: "Canon CRG-041",
        kompatibilnost: "Canon LBP312X/LBP312dn",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        link: "CRG-052",
        ime: "Canon CRG-052",
        kompatibilnost: "Canon i-Sensys LBP212dw, LBP214dw, LBP215x, MF421de, MF426dw, MF428x, MF429x",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3100,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        link: "CRG-040",
        ime: "Canon CRG-040 BK/MG/YL/C",
        kompatibilnost: "Canon Color image class LBP712DN/ i-Sensys LBP710CX/712CX/",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        link: "CRG-054-BK",
        ime: "Canon CRG-054 BK",
        kompatibilnost: "Canon Color image class MF640c, MF642CDW, MF643CDW, MF644CDW, MF645CX, LBP622CDW, LBP623CDW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        link: "CRG-054-MG",
        ime: "Canon CRG-054 MG",
        kompatibilnost: "Canon Color image class MF640c, MF642CDW, MF643CDW, MF644CDW, MF645CX, LBP622CDW, LBP623CDW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200,
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        link: "CRG-054-YL",
        ime: "Canon CRG-054 YL",
        kompatibilnost: "Canon Color image class MF640c, MF642CDW, MF643CDW, MF644CDW, MF645CX, LBP622CDW, LBP623CDW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        link: "CRG-054-CY",
        ime: "Canon CRG-054 CY",
        kompatibilnost: "Canon Color image class MF640c, MF642CDW, MF643CDW, MF644CDW, MF645CX, LBP622CDW, LBP623CDW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200,
    }
]

export const hp = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 15A/13A/24A",
        kompatibilnost: "HP 1000,1200,1200N,3330,3380",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP 17A",
        kompatibilnost: "HP M102w,MFP M130fn,MFP M130fw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1600,
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink2.jpg",
        ime: "HP 19A",
        kompatibilnost: "HP M102w,MFP M130fn,MFP M130fn",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 30A",
        kompatibilnost: "HP Pro MFP M227fdn,HP LaserJet Pro M203dw,HP LaserJet Pro MFP M227fdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1600,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP 30X",
        kompatibilnost: "HP Pro MFP M227fdn,HP LaserJet Pro M203dw,HP LaserJet Pro MFP M227fdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3500,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 32A",
        kompatibilnost: "HP Pro MFP M227fdn,HP LaserJet Pro M203dw,HP LaserJet Pro MFP M227fdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 23000, 
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 44A",
        kompatibilnost: "HP Laser Jet M15,HP Laserjet Pro M28",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP 89A",
        kompatibilnost: "HP HP Laser Jet Enterprice M507/MFP528 sa cipom",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 59A",
        kompatibilnost: "HP Laserjet M304/M404/M424 sa čipom",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4.png",
        ime: "HP 59A",
        kompatibilnost: "HP Laserjet M304/ M404/ M424 bez čipa",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 59X",
        kompatibilnost: "HP Laserjet M304/M404/M424 sa čipom",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 12,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink2.jpg",
        ime: "HP W1106A",
        kompatibilnost: "HP Laser 107/ MFP135a/ag/r/w/wg/ 137fnw/fwg sa čipom",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 13,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP W1335",
        kompatibilnost: "HP LaserJet M438/M440/M442/M443 sa čipom",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7400,
    },

    {
        id: 14,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP 10A",
        kompatibilnost: "HP 2300/2300N/2300DN/2300D/2300DTN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 15,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 12A",
        kompatibilnost: "HP 1010/20/22, 3020/30/50/52, 3055/CANON LBP 2900/3000/CANON L-100/120, MF4120/4140/4150",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 16,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 16A",
        kompatibilnost: "HP 5200/5200N/5200TN/520DTN/5200L/CANON LBP 3500/3900/3920/3970",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 17,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 43X",
        kompatibilnost: "HP Laser Jet 9000",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 30000,
    },

    {
        id: 18,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP 70A",
        kompatibilnost: "HP Laser Jet M5025 MFP/ M5035 MFP/ M5035XMFP/ M5035XS M/ M5035X MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 19,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 26A",
        kompatibilnost: "HP Laser Jet Pro M402, HP Laser Jet Pro M426",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3100,
    },

    {
        id: 20,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 26X",
        kompatibilnost: "HP Laser Jet Pro M402, HP Laser Jet Pro M426",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 9000,
    },

    {
        id: 21,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP 29X",
        kompatibilnost: "HP 5000, 5100",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 22,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink2.jpg",
        ime: "HP 49A",
        kompatibilnost: "HP 1160, 1320, 1320T, 1320N, 1320NW, 1320TN, MFC 3390",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 23,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 49X",
        kompatibilnost: "HP 1160, 1320, 1320T, 1320N, 1320NW, 1320TN, MFC 3390",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7000,
    },

    {
        id: 24,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP 55A",
        kompatibilnost: "HP Laser Jet P3015/ P3015D/ P3015DN/ P3015X",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 25,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 55X",
        kompatibilnost: "HP Laser Jet P3015/ P3015D/ P3015DN/ P3015X",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12500,
    },

    {
        id: 26,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 53A",
        kompatibilnost: "HP 2015/CANON LBP-3300/3360",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 27,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP 53X",
        kompatibilnost: "HP 2015/CANON LBP-3300/3360",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7000,
    },

    {
        id: 28,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 05A",
        kompatibilnost: "HP 2035/2055, CANON LBP-6300/6650/6680/6310/6670 MF-5880/5980/5840/5940",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2700,
    },

    {
        id: 29,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP 05X",
        kompatibilnost: "HP 2035/2055, CANON LBP-6300/6650/6680/6310/6670 MF-5880/5980/5840/5940",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6500,
    },

    {
        id: 30,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 11A",
        kompatibilnost: "HP 2410, 2420, 2430",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 31,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 51A",
        kompatibilnost: "HP Laser Jet M3027/M3035MFP/P3005/P3005DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6500,
    },

    {
        id: 32,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP 79A",
        kompatibilnost: "HP LaserJet Pro M12/M12a/M12w/M26a",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 33,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 80A",
        kompatibilnost: "HP M401/M425",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2700,
    },

    {
        id: 34,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 80X",
        kompatibilnost: "HP M401/M425",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6900,
    },

    {
        id: 35,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink2.jpg",
        ime: "HP 81A",
        kompatibilnost: "HP Laser Jet Enterprise M604n/ M604dn/ M605n/ M605dn/ M606dn/ MFP M630",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10500,
    },

    {
        id: 36,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 56A",
        kompatibilnost: "HP Laserjet M436N M436NDA",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6600,
    },

    {
        id: 37,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP 37A",
        kompatibilnost: "HP Laser Jet M631/ M632/ M633/ M607/ M608/ M609",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 11000,
    },

    {
        id: 38,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 35A",
        kompatibilnost: "HP P1005/1006, CANON LBP-3010/3018/3050",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1600,
    },

    {
        id: 39,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 85A",
        kompatibilnost: "HP P110, CANON LBP-6018/6000/6020 MF 3010",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1600,
    },

    {
        id: 40,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "HP 36A",
        kompatibilnost: "HP P1505/P1505N/M1522, CANON LBP-3250",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1600,
    },

    {
        id: 41,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP 78A",
        kompatibilnost: "HP P1560/1566/1322/1530, CANON MF-4410/4420/4430/ D-520",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2100,
    },

    {
        id: 42,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "HP 38A/39A/42X/45A",
        kompatibilnost: "HP Laser Jet UNIVERZALNI 4200/ 4300/ 4250/ 4350/ 4345",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 20000,
    },

    {
        id: 43,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "HP 83A",
        kompatibilnost: "HP Laser Jet Pro 400 M125/ M127FN/ M127FW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500,
    },

    {
        id: 44,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 83X/CRG-737",
        kompatibilnost: "HP Laser Jet LJ M201, LJ M225 MFP/CANON CRG-737 MF 211/212/216/217/226",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2200,
    },

    {
        id: 45,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 87A",
        kompatibilnost: "HP Laser Jet Enterprise M506n/ M506dn/ M506x/ MFP M527",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 9000,
    },

    {
        id: 46,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink2.jpg",
        ime: "HP 90A / 64A",
        kompatibilnost: "HP Laser Jet Enterprise M4555h MFP/ M4555f MFP/ M4555fskm MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 47,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 90X / 64X",
        kompatibilnost: "HP Laser Jet Enterprise M4555h MFP/M602n/ M602dn/ M602x/ M603/ M603n/ M603dn/ M603xh",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 24000,
    },

    {
        id: 48,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 92A",
        kompatibilnost: "HP 1100/1100A/3200/CANON LBP-800/810/1110/1122/EP-22",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 49,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 96A",
        kompatibilnost: "HP 2100/2200/CANON LBP-470/1000/1310/EP-32",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 50,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP 61A/27A",
        kompatibilnost: "HP Laser Jet 4100",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 51,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP 14A",
        kompatibilnost: "HP Laser Jet Pro 700 M712/ M715/ M725; Canon LBP8710/ 8720/ 8750/ 8780",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 52,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP W2070/W2071/W2072/W2073 (117A)",
        kompatibilnost: "HP Color Laser 150a/ MFP 178/179 series sa čipom",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 53,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP 415A",
        kompatibilnost: "HP Color LaserJett Pro M454dn/ M454dw/ MFP M479dw/ M479fdn/ M479fdw bez čipa",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2400,
    },

    {
        id: 54,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP 216A",
        kompatibilnost: "HP ColorLaserjet Pro M155/ MFP M182nw/ M183fw  bez čipa",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 55,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP CE340A/341A/342A/343A",
        kompatibilnost: "HP Color Laser Jet 700/ M775z+",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 13000,
    },

    {
        id: 56,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP CF530A/531A/532A/533A",
        kompatibilnost: "HP Color Laser Jet Pro MFP M180/M180n/M181/M181fw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 57,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "HP CF540A/541A/542A/543A",
        kompatibilnost: "Color LaserJet Pro M254dw/ M254nw/ MFP M280nw/ MFP M281fdn/ MFP M281fdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1300,
    },

    {
        id: 58,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP CE400A/401A/402A/403A",
        kompatibilnost: "HP Color LaserJet EP-500 M 551N",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6500,
    },

    {
        id: 59,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink2.jpg",
        ime: "HP CF400X/401X/402X/403X",
        kompatibilnost: "HP Color Laser Jet Pro M252, HP Color Laser Jet Pro MFP274, HP ColorLaser Jet Pro MFP277",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 60,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP CE320A/321A/322A/323A",
        kompatibilnost: "HP LaserJet CP1525N/CM1415FNW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 61,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP CE310A/311A/312A/313A",
        kompatibilnost: "HP LaserJet CP1025/CP1025NW/Canon CRG-729",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200,
    },

    {
        id: 62,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "CE314A DRUM UNIT",
        kompatibilnost: "HP LaserJet CP1025/CP1025NW/Canon CRG-729",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 14000,
    },

    {
        id: 63,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP CE410A/411A/412A/413A",
        kompatibilnost: "HP Color Laser Jet PRO 300MFP375NW/ PRO 400 M451DN/ M451DW/ M451NW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 64,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP CC530A/531A/532A/533A",
        kompatibilnost: "HPCP 2025/CM 2320/CANON 7200",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 65,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP CB 540A/541A/542A/543A",
        kompatibilnost: "HPCP 1215/1217/1510/1415/1515/1517/1518/CANON LBP 5050/CRG-716",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 66,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP Q6470A/71A/72A/73A",
        kompatibilnost: "HP Color Laser Jet 3600/ 3800",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 67,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP CE270A/71A/72A/73A",
        kompatibilnost: "HP Color Laser Jet CP5520/5525N/5525DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 68,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "HP Q5950A/51A/52A/53A",
        kompatibilnost: "HP Color Laser Jet 4700/4700N/4700DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 69,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP C9720A/9721A/9722A/9723A",
        kompatibilnost: "HP Color Laser Jet 4600/ 4650/ Canon EP85",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 8500,
    },

    {
        id: 70,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink2.jpg",
        ime: "HP C9730A/9731A/9732A/9733A",
        kompatibilnost: "HP Color Laser Jet 5500/ 5550",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 71,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP CE740A/741A/742A/743A",
        kompatibilnost: "HP Color Laser Jet CP 5225",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7000,
    },

    {
        id: 72,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP Q6000A/6001/6002/6003",
        kompatibilnost: "HP 1600/2600/2605/CANON LBP-5000/CRG-707",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 73,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "HP CF410A/411A/412A/413A",
        kompatibilnost: "HP Color Laser Pro 452dn/MFP 477fdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2300
    },

    {
        id: 74,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "HP CF360A/361A/362A/363A",
        kompatibilnost: "HP Color Laser Jet Enterprise M552DN/ M553N/DN/X/ MFP M577DN/C/F/Z",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5500,
    },

    {
        id: 75,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP CE260A/261A/262A/263A",
        kompatibilnost: "HP Color Laser Jet 4025N/ 4025DN/ CP4525DN/ CP4525N/ CP4525XH",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 76,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "HP CF350/351/352/353A",
        kompatibilnost: "HP Color Laser Jet PRO MFP M176N/ 177FW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200,
    },

    {
        id: 77,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "HP CF210A/211A/212A/213A",
        kompatibilnost: "HP Color Laser Jet PRO 200 M251NW / M276NW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 78,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "HP CF380A/381A/382A/383A",
        kompatibilnost: "Color LaserJet Pro MFP M 476 DN, Color LaserJet Pro MFP M 476 NW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },
]

export const kyocera = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TK-130",
        kompatibilnost: "Kyocera FS-1300D/1300DN/1128MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7200,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TK-160",
        kompatibilnost: "Kyocera FS-1120D/1120DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "TK-170",
        kompatibilnost: "Kyocera FS-1320D/ 1370DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7200,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TK-17",
        kompatibilnost: "Kyocera FS-1000/ 1010/ 1010N/ 1050/ 1010+",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TK-120/122",
        kompatibilnost: "Kyocera FS-1030",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7200,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TK-1110",
        kompatibilnost: "Kyocera FS-1040/ 1020MFP/ 1120MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TK-1120",
        kompatibilnost: "Kyocera FS-1060DN/FS-1025MFP/FS-1125MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "TK-1130",
        kompatibilnost: "Kyocera FS-1030/ 1130MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TK-1140",
        kompatibilnost: "Kyocera FS-1035MFP/ 1135MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7200,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "TK-1150",
        kompatibilnost: "Kyocera Ecosys M2135dn/ M2635dn/ M2735dw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "TK-1160",
        kompatibilnost: "Kyocera Ecosys P2040dn/ P2040dw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7200,
    },

    {
        id: 12,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TK-1170",
        kompatibilnost: "Kyocera Ecosys M2040dn/ M2540dn/ M2640idw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7200,
    },

    {
        id: 13,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TK-320/322",
        kompatibilnost: "Kyocera FS-3900DN/ 4000DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 14,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TK-330/332",
        kompatibilnost: "Kyocera FS-4000DN/ 4000DTN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 20000,
    },

    {
        id: 15,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TK-340",
        kompatibilnost: "Kyocera FS-2020D/ 2020DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 16,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "TK-350",
        kompatibilnost: "Kyocera FS-3920D",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 17,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TK-360",
        kompatibilnost: "Kyocera FS-4020D/4020DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 20000,
    },

    {
        id: 18,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "TK-435",
        kompatibilnost: "Kyocera Toner copier TASKalfa 180/181/220/221,TK435",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 19,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TK-475",
        kompatibilnost: "Kyocera Toner copier FS 6025MFP-6025 MFP B-6030MFP, TK475",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000
    },

    {
        id: 20,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TK-110/11/112/113",
        kompatibilnost: "Kyocera FS-720/ 820/ 920/ 1116MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 21,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TK-3100",
        kompatibilnost: "Kyocera FS-2100D/DN/ 4100DN/ 4200DN/ 4300DN/ Ecosys M3040DN/ M3540DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12500,
    },

    {
        id: 22,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TK-3130",
        kompatibilnost: "Kyocera FS-4200DN/ 4300DN/ Ecosys M3040idn/ M3560idn",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 25000,
    },

    {
        id: 23,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TK-3160",
        kompatibilnost: "Kyocera Ecosys P3045DN/P3050DN/P3055DN/P3060DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12500,
    },

    {
        id: 24,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "TK-3170",
        kompatibilnost: "Kyocera ECOSYS P3050dn/ P3055dn/ P3060dn",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15500,
    },

    {
        id: 25,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TK-3190",
        kompatibilnost: "Kyocera ECOSYS P3050dn/ P3055dn/ P3060dn",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 25500,
    },

    {
        id: 26,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TK-410/411/412",
        kompatibilnost: "Kyocera KM-1635/ 2035/ 1650/ 2050",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 27,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TK-4105",
        kompatibilnost: "Kyocera Taskalfa 1800/ 2200/ 1801/ 2201",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 28,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "TK-715",
        kompatibilnost: "Kyocera KM-3050/ KM-4050/ KM-5050",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 34000,
    },

    {
        id: 29,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TK-5230 BK/CY/MG/YL",
        kompatibilnost: "Kyocera Ecosys M5521cdn/ M5521cdw/ P5021cdn/ P5021cdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 30,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink4.jpg",
        ime: "TK-5240 BK/CY/MG/YL",
        kompatibilnost: "Kyocera Ecosys M5526MFP/ P5026",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3500,
    },

    {
        id: 31,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TK-5270 BK/CY/MG/YL",
        kompatibilnost: "ECOSYS P6230cdn/ M6230cidn/ M6630cidn",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7000,
    },

    {
        id: 32,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TK-580/BK/CY/MG/YL",
        kompatibilnost: "Kyocera FS-5150DN/P6021",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    }
]

export const samsung = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "MLT-1042L",
        kompatibilnost: "Samsung 1660/1661/1665/1666",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "MLT-1052L",
        kompatibilnost: "Samsung 1910/1911/1915/2525/2580/SCX-4600/4601/4606/4623",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "MLT-108S",
        kompatibilnost: "Samsung 1640/1641/2240/2241",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "ML 1710D3",
        kompatibilnost: "Samsung 1520/1710/1740/1750/SCX-4016/4116/4216/SF560/750",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "ML 1610",
        kompatibilnost: "Samsung 1610/2010/2010R/2510/2570/2571N/SCX-4321/4521F",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "MLT-D-101L",
        kompatibilnost: "Samsung ML-2161/2162G/2166W/SF 761/761P/SCX 3401/3406/3405",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500,
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "SCX 4200",
        kompatibilnost: "Samsung SCX 4200",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "MLT-109L",
        kompatibilnost: "Samsung SCX 4300",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "MLT-D209",
        kompatibilnost: "Samsung ML2855ND/ SCX-4824FN/ 4826FN/ 4828FN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "ML-2850",
        kompatibilnost: "Samsung ML-2850D/ 2851ND",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "SCX 5530",
        kompatibilnost: "Samsung SCX 5530",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 8000,
    },

    {
        id: 12,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "ML-D4550",
        kompatibilnost: "Samsung ML 4050N, 4550, 4550 R, 4551 ND, 4551 NR, 4551 NDR,4551N LC",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 13,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "ML-3470",
        kompatibilnost: "Samsung ML-3470D/ 3470ND/ 3471DK/ 3470ND",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 14,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "MLT-D305L",
        kompatibilnost: "Samsung ML-3750DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 15,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "MLT-D307E",
        kompatibilnost: "Samsung ML 4510, ML 5010, ML 5015",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 20000,
    },

    {
        id: 16,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "MLT-R307E",
        kompatibilnost: "Samsung ML 4510, ML 5010, ML 5015",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 60000,
    },

    {
        id: 17,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "SCX-6545/6555",
        kompatibilnost: "Samsung SCX-6555N, Samsung SCX-6555NX",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 25000,
    },

    {
        id: 18,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "SCX-6545/6555",
        kompatibilnost: "Samsung SCX-6555N, Samsung SCX-6555NX",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 80000,
    },

    {
        id: 19,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "MLT-D-203L",
        kompatibilnost: "Samsung ProXpress M3320nd/ M3370nd/fs/ M3820dw/fd/fw/ M4020nd/nx/ M4070nd/fd/fr",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 20,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "MLT-D-204L",
        kompatibilnost: "Samsung M3325/ 3825/ 4025, M3375/ 3875/ 4075",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 21,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "MLT-R204",
        kompatibilnost: "Samsung M3875, M4075, M4025, M3825, M3375, M3325",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 30000,
    },

    {
        id: 22,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "MLT-D-205L",
        kompatibilnost: "Samsung ML-3300/ 3310D/ 3310ND/ 3710D/3710ND/ SCX-5637FR/ 4833FR/ 4833FD",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 23,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "ML-D-208L",
        kompatibilnost: "Samsung ML-3475/ SCX-5635/58/35",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 24,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "MLT-D116",
        kompatibilnost: "Samsung Xpress M2676N, M2676FH, M2876HN, M2626, M2626D, M2826ND",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 25,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "R-116 DRUM UNIT",
        kompatibilnost: "Samsung Xpress M2676N, M2676FH, M2876HN, M2626, M2626D, M2826ND",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 9000,
    },

    {
        id: 26,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "MLT-D103",
        kompatibilnost: "Samsung SCX-4729HD/ 4728HN/ ML-2956ND/ 2950/ 2951D/ 2956DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 27,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "MLT-D111S",
        kompatibilnost: "Samsung Xpress M2020/ 2020W/ 2026/ M2022/ 2022W/ M2070/ 2070W",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 28,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "MLT-D111L",
        kompatibilnost: "Samsung Xpress M2020/ 2020W/ 2026/ M2022/ 2022W/ M2070/ 2070W",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1800,
    },

    {
        id: 29,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "MLT-D-117",
        kompatibilnost: "Samsung SCX-4650F/4650N/4652F/4655F/4655FN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500
    },

    {
        id: 30,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "ML-3050",
        kompatibilnost: "Samsung ML3050/ 3051/ 3051N/ 3051ND",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 8000,
    },

    {
        id: 31,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "CLT-508L BK,MG,CY,YL",
        kompatibilnost: "Samsung CLP-620/670",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 4500,
    },

    {
        id: 32,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "CLT-6092S BK,MG,CY,YL",
        kompatibilnost: "Samsung CLP-775DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 7000,
    },

    {
        id: 33,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink5.jpg",
        ime: "CLP-680 BK,MG,CY,YL",
        kompatibilnost: "Samsung CLP-680/CLX 6260",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 34,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "CLT-K404S BK,MG,CY,YL",
        kompatibilnost: "Samsung Xpress C430W, Samsung Xpress C480W, Samsung Xpress C480WF",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1250,
    },

    {
        id: 35,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "CLT-407S BK,MG,CY,YL",
        kompatibilnost: "Samsung CLP-320, 325, 326",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1250,
    },

    {
        id: 36,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink6.jpg",
        ime: "CLT-409S BK,MG,CY,YL",
        kompatibilnost: "Samsung CLP-310N, 315",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1250,
    },

    {
        id: 37,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "CLT-406S BK,MG,CY,YL",
        kompatibilnost: "Samsung CLP-365W, CLX-3350FW, C410W SL-C410W/XAA",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1250,
    },
]

export const lexmark = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "E260A11A",
        kompatibilnost: "Lexmark E260, E260D, E260DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3500,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "E260X22G DRUM",
        kompatibilnost: "Lexmark E260, 360, 460, X264, X363, X364",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 30000
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "E250A11A",
        kompatibilnost: "Lexmark E250, 250DN, 350D, 350DN, 352DN, DELL 1720",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3500,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "X203A11G",
        kompatibilnost: "Lexmark X203, X203N, X204, X204N",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "X264H21G",
        kompatibilnost: "Lexmark X264, X363DN, X364DN, E364DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 9000,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "12A8305",
        kompatibilnost: "Lexmark E230/ 232/ 330/ 332/ 234/ 240/ 340/ 342, DELL 1700/ 1710, IBM1412/1512",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "12A8302",
        kompatibilnost: "Lexmark E230/ 232/ 240/ 330/ 340/ X203",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 30000,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "12035SA",
        kompatibilnost: "Lexmark E120/ 122N",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "50F5H00",
        kompatibilnost: "Lexmark MS-310/ 312/ 315/ 410/ 415/ 510/ 610",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "50F500",
        kompatibilnost: "Lexmark MS-310/ 312/ 315/ 410/ 415/ 510/ 610",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "60F5H00",
        kompatibilnost: "Lexmark MX-310/ 410/ 510/ 511/ 610/ 611",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 12,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "60F5000",
        kompatibilnost: "Lexmark MX-310",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 13,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "51B5000",
        kompatibilnost: "Lexmark MS/MX317 /417/ 517/ 617",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 14,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "51B5000",
        kompatibilnost: "Lexmark MS/MX 417/ 517/ 617",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 8500,
    },

    {
        id: 15,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "50F0Z00",
        kompatibilnost: "Lexmark MS310/ MS410/ MS510/ MS610/ MX310/ MX410/ MX510/ MX610",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 60000,
    },

    {
        id: 16,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "12A7462",
        kompatibilnost: "Lexmark T630/ T630DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 21000,
    },

    {
        id: 17,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "64015HA",
        kompatibilnost: "Lexmark T640/ 642/ 644 (sa SCC cipom)",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 21000,
    },

    {
        id: 18,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "T650H21E",
        kompatibilnost: "Lexmark T650/ 652/ 654/ 656",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 25000,
    },

    {
        id: 19,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "CS310 BK/YL/MG/CY",
        kompatibilnost: "Lexmark CS310/ CS410/ CS510",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3500,
    },

    {
        id: 20,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "CX310 BK/YL/MG/CY",
        kompatibilnost: "Lexmark CX310/ CX410/ CX510",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 89.90
    },

    {
        id: 21,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "C540 BK/YL/MG/CY",
        kompatibilnost: "Lexmark C540N/ C543DN/ C544DN/ C544N/ C544DTN/ C544DW/ C544DW/ C546DTN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    }
]

export const xerox = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "Xerox 3040",
        kompatibilnost: "Xerox Phaser 3040B/ 3010B",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2200,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "Xerox 106R02778",
        kompatibilnost: "Xerox Phaser 3215/ 3260/ WorkCentre 3052/ 3225",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "Xerox 101R00474",
        kompatibilnost: "Xerox drum unit 3225/3260",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "Xerox 108R00909",
        kompatibilnost: "Xerox Phaser 3140",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "Xerox 106R01379",
        kompatibilnost: "Xerox Phaser 3100",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 4000,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "Xerox 3250",
        kompatibilnost: "Xerox Phaser 3250",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "Xerox 106R01414",
        kompatibilnost: "Xerox Phaser 3435MFP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "Xerox PE220",
        kompatibilnost: "Xerox Workcentre PE220",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "Xerox 106R02721",
        kompatibilnost: "Xerox Phaser 3610DN/ WorkCentre 3615DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5900,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "Xerox 106R02310",
        kompatibilnost: "Xerox WorkCentre 3315/ 3325",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "Xerox 106R03623",
        kompatibilnost: "Xerox Phaser 3330",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 12,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "Xerox 106R04347/106R04347",
        kompatibilnost: "Xerox B205/B210/B215",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 13,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "Xerox 106R02773",
        kompatibilnost: "Xerox Phaser 3020e, Workcentre 3025",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500,
    },

    {
        id: 14,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "Xerox 113R00711",
        kompatibilnost: "Xerox Phaser 4510/ 4510B/ 4510N/ 4510DT/ 4510DX",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 15,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "Xerox 3210/ 3220",
        kompatibilnost: "Xerox WorkCentre 3210/3210N/3220/3220DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5000,
    }
]

export const minolta = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-114",
        kompatibilnost: "Bizhub 162/ 163/ 210/ 7516",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 11000,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-116/117/118",
        kompatibilnost: "Bizhub 164/165/185/210/211/215",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 11000
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "TN-211",
        kompatibilnost: "Bizhub 200/ 222/ 282",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 17500,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TN-217",
        kompatibilnost: "Bizhub 223/ 283",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 17500,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "TN-322",
        kompatibilnost: "Bizhub 364/ 284/ 224",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 24000,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TN-323",
        kompatibilnost: "Bizhub 227/ 287/367",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 23000
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-216 BK",
        kompatibilnost: "Bizhub C220/ C280/ 360",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 29000
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-216 MG,CY,YL",
        kompatibilnost: "Bizhub C220/ C280/ 360",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 26000
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-321 BK",
        kompatibilnost: "Bizhub C224/ C284/ C364",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 27000,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-321 MG,CY,YL",
        kompatibilnost: "Bizhub C224/ C284/ C364",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 25000,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "TN-324 BK",
        kompatibilnost: "Bizhub C258/ C308/ C368",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 28000,
    },

    {
        id: 12,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-324 MG,CY,YL",
        kompatibilnost: "Bizhub C258/ C308/ C368",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 26000,
    },

    {
        id: 13,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "PagePro 1480",
        kompatibilnost: "Konica Minolta PagePro 1480/1490MF sa IC karticom",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 5500,
    },

    {
        id: 14,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "PagePro 1300",
        kompatibilnost: "Konica Minolta PagePro 1300W/ 1350W/ 1350WN/ 1380MF/ 1390MF",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    }
]

export const epson = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "M2000",
        kompatibilnost: "M-2000/2010",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 8000,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "M1200",
        kompatibilnost: "Epson M-1200",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1800,
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "M1400",
        kompatibilnost: "Epson M-1400/ MX14/ MX14NF",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2200
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "M2300",
        kompatibilnost: "Epson M-2300/ MX20/ M2400",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 8000,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "M200",
        kompatibilnost: "Epson AL-M200/ MX200/ M200DN/ M200DW/ MX200DNF/ MX200DWF",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "M300",
        kompatibilnost: "Epson M300D/DN/DT/DTN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    }
]

export const brother = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "TN-2000/TN350",
        kompatibilnost: "DCP 7010 L, DCP 7010, DCP 7020, DCP 7025, FAX 2820, FAX 2825, FAX 2920,HL 2030, HL 2040",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-2010",
        kompatibilnost: "Brother HL 2130, DCP 7055, TN 2010 LC",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-2110/ TN330",
        kompatibilnost: "Brother HL 2140, 2150, 2170, DCP 7030, 7040, 7045 N, HL 2140, 2150N, 2170W",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TN-1050",
        kompatibilnost: "Brother HL 1110, HL 1111, HL 1112, HL 1118, DCP 1510, DCP 1511, DCP 1512, DCP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1000,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "DR-1000/1030/1050",
        kompatibilnost: "Brother HL 1110, HL 1111, HL 1112, HL 1118, DCP 1510, DCP 1511, DCP 1512, DCP",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TN-1090",
        kompatibilnost: "Brother HL-1222WE, DCP-1622WE",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1500
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "DR-1090",
        kompatibilnost: "Brother HL-1222WE, DCP-1622WE",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-2120/ TN360",
        kompatibilnost: "Brother HL 2140, 2150, 2170, DCP 7030, 7040, 7045 N, HL 2140, 2150N, 2170W",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2600
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-2210/ TN420",
        kompatibilnost: "Brother HL 2240D, 2250DN, 2270DW, MFC 7360N, 7460DN, 7860DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-2220",
        kompatibilnost: "Brother HL 2240D, 2250DN, 2270DW, MFC 7360N, 7460DN, 7860DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2600,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "DR-2200",
        kompatibilnost: "Brother HL 2240D, 2250DN, 2270DW, MFC 7360N, 7460DN, 7860DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 12,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TN-2310/ TN630",
        kompatibilnost: "Brother HL L2300D, HL L2340DW, HL L2360DN, HL L2365DW, DCP L2500D",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200,
    },

    {
        id: 13,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TN-2320",
        kompatibilnost: "Brother HL L2300D, HL L2340DW, HL L2360DN, HL L2365DW, DCP L2500D",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2600,
    },

    {
        id: 14,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "DR-2300",
        kompatibilnost: "Brother HL L2300D, HL L2340DW, HL L2360DN, HL L2365DW, DCP L2500D",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 15,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-2410/TN730",
        kompatibilnost: "Brother HL-L2310D, HL-L2350DW, HL-L2375DW, DCP-L2510D,MFC-L2710DW, MFC-L2730DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1200
    },

    {
        id: 16,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TN-2420",
        kompatibilnost: "Brother HL-L2310D, HL-L2350DW, HL-L2375DW, DCP-L2510D,MFC-L2710DW, MFC-L2730DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 17,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-2421",
        kompatibilnost: "Brother DCP-L2512/L2532/L2552, HL-L2312/L2352/L2372, MFC-L2712/L2732",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 18,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "DR-2401",
        kompatibilnost: "Brother DCP-L2512/L2532/L2552, HL-L2312/L2352/L2372, MFC-L2712/L2732",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 19,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TN-B023",
        kompatibilnost: "Brother HL-B2080DW/ DCP-7520DW/MFC-B7715DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 20,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "DR-B023",
        kompatibilnost: "Brother HL-B2080DW/ DCP-7520DW/MFC-B7715DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 21,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-3512",
        kompatibilnost: "Brother HL-6180D/ HL-6180W/ HL-6180DWT/ DCP-8250/ MCF-8950DWT",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 12000,
    },

    {
        id: 22,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TN-3130",
        kompatibilnost: "Brother DCP 8060, DCP 8065DN, HL 5240, HL 5240L, HL 5250DN, HL 5270DN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3500
    },

    {
        id: 23,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        ime: "TN-3230/ TN620",
        kompatibilnost: "Brother DCP 8070 D, 8085 DN, HL 5340 D, 5350 DN, 5350 DNLT, 5380 DN, MFC 8370",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 24,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "TN-3330/ TN720",
        kompatibilnost: "Brother TN3330, TN3320, TN53J, HL5440, HL5350, HL5370, HL5380, HL5450, HL5470",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 3000,
    },

    {
        id: 25,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TN-3480",
        kompatibilnost: "Brother DCP L5500DN, DCP L5600DN, DCP L5650DN,MFC L5800DW, MFC L5850DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 8000,
    },

    {
        id: 26,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        ime: "DR-3400",
        kompatibilnost: "Brother DCP L5500DN, DCP L5600DN, DCP L5650DN,MFC L5800DW, MFC L5850DW",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 30000,
    },

    {
        id: 27,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "TN-230 BK,MG,YL,CY",
        kompatibilnost: "Brother HL 3040, HL 3040CN, HL 3070CW, DCP 9010CN, MFC 9120",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 1700,
    },

    {
        id: 28,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        ime: "TN-241 BK,MG,YL,CY",
        kompatibilnost: "Brother DCP 9020cdw,HL3140cw,HL3170cdw, MFC-9340cdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 29,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor1.jpg",
        ime: "DR-241 BK,MG,YL,CY",
        kompatibilnost: "Brother DCP 9020cdw,HL3140cw,HL3170cdw, MFC-9340cdw",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000
    },

    {
        id: 30,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        ime: "TN-247 BK,MG,YL,CY",
        kompatibilnost: "Brother HL-L3210,Brother HL-L3270,Brother DCP-L3510,Brother MFC-L3730",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2600,
    },

    {
        id: 31,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        ime: "TN-6600/ TN460",
        kompatibilnost: "Brother FAX 8750, HL 1030, HL 1230, HL 1240, HL 1250,MFC 9760, MFC 9870, MFC 9880",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 6000,
    }
]

export const panasonic = [
    {
        id: 1,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        link: "kx-fa-91",
        ime: "Panasonic KX-FA-91/52",
        kompatibilnost: "KX-FC225,226,228,253,KX-FT218,205,206,207",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: null,
    },

    {
        id: 2,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        link: "kx-fa-92",
        ime: "Panasonic KX-FA-92/54/54E",
        kompatibilnost: "KX-FP-148,376,381",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: null,
    },

    {
        id: 3,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        link: "kx-fa-93",
        ime: "Panasonic KX-FA-93/57",
        kompatibilnost: "KX-FM-331,332,351,352",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: null,
    },

    {
        id: 4,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        link: "kx-fat92e",
        ime: "Panasonic KX-FAT92E/94C",
        kompatibilnost: "KX-MB262/ 263/ 772/ 773/ 783/ 788",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 5,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor4-1024x1024.png",
        link: "kx-fa-411a",
        ime: "Panasonic KX-FA-411A",
        kompatibilnost: "KX-411A",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 6,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        link: "kx-fad412a",
        ime: "KX-FAD412A",
        kompatibilnost: "KX-MB1900/ 2000/ 2010/ 2020/ 2025/ 2030/ 2061/ 2062 DRUM UNIT",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 7,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        link: "kx-fat472",
        ime: "KX-FAT472",
        kompatibilnost: "KX-MB2120/ 2130/ 2170/ 2137/ 2177/ 2128/ 2178/ 2138/ 2168",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    },

    {
        id: 8,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor2.jpg",
        link: "kx-fad473",
        ime: "KX-FAD473",
        kompatibilnost: "KX-MB2120/ 2130/ 2170/ 2137/ 2177/ 2128/ 2178/ 2138/ 2168 DRUM UNIT",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 15000,
    },

    {
        id: 9,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink3.jpg",
        link: "kx-fa-83a",
        ime: "Panasonic KX-FA-83A",
        kompatibilnost: "KX-FL511/512/541/612",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2500,
    },

    {
        id: 10,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/starink1.jpg",
        link: "kx-fa84a",
        ime: "Panasonic KX-FA84A",
        kompatibilnost: "KX-FL511/ 512/ 513/ 540/ 541/ 543/ 611/ 611F/ 611G/ FLM651",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 10000,
    },

    {
        id: 11,
        slika: "http://www.greenton.ba/wp-content/uploads/2023/03/mastercolor3.jpg",
        link: "kx-fa-88a",
        ime: "Panasonic KX-FA-88A",
        kompatibilnost: "KX-803N/813N/853CN",
        cijena: "Na upit",
        stanje: "Imamo na stanju",
        ispis: 2000,
    }
]